module.exports = "https://web-assets.ifttt.com/packs/media/docs/ecosystem_logos-7c304539.png";